import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { RacwaDetailedDialog } from "@racwa/react-components";
import { InsurancePhoneNumberLink } from "raci-react-library";

const id = "policy-not-listed-dialog";

export interface PolicyNotListedDialogProps {
  showDialog: boolean;
  setShowDialog: (open: boolean) => void;
}

export const PolicyNotListedDialog: React.FC<PolicyNotListedDialogProps> = ({ showDialog, setShowDialog }) => {
  return (
    <RacwaDetailedDialog
      open={showDialog}
      onClose={() => setShowDialog(false)}
      onClickClose={() => setShowDialog(false)}
      title="Policy not listed"
      titleId={`${id}-title`}
      id={id}
    >
      <Grid container spacing={2} data-testid={`${id}-content`}>
        <Grid>
          <Typography>
            If you'd like to discuss this or if you think there's been a mistake, call us on{" "}
            <InsurancePhoneNumberLink id={`${id}-phone-number-link`} />.
          </Typography>
        </Grid>
      </Grid>
    </RacwaDetailedDialog>
  );
};
